import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
} from "../actions/types";

const apikey = localStorage.getItem("apikey");

const initialState = apikey
  ? { isLoggedIn: true, apikey }
  : { isLoggedIn: false, apikey: null };

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        apikey:payload.apikey,
        payload
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        apikey: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        apikey: null,
      };
    default:
      return state;
  }
}
